import React from 'react';
import { connect } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router/immutable';

import type { ConnectedProps } from 'react-redux';
import type { History } from 'history';

import { getIsHotelOnly } from 'src/store/view/selectors';
import { getIsFirstStepDone } from '../../../store/selectors/order';
import { getIsHomePath } from '../../../store/selectors/router';

import { PACKAGE_HOME_PATH, CLIENT_PATH } from '../../../store/constants';

import Layout from '../containers/Layout';
import RedirectToPage from '../../../components/RedirectToPage';

interface RoutesProps extends PropsFromRedux {
  history: History;
}

const Routes = (props: RoutesProps) => {
  const { history, redirectToHome, isHomePath, isHotelOnly } = props;

  return (
    <>
      {/** @ts-ignore */}
      <ConnectedRouter history={history}>
        <>
          {redirectToHome && !isHomePath && (
            <RedirectToPage
              path={isHotelOnly ? CLIENT_PATH : PACKAGE_HOME_PATH}
            />
          )}

          <Layout />
        </>
      </ConnectedRouter>
    </>
  );
};

const mapStateToProps = (state) => ({
  redirectToHome: !getIsFirstStepDone(state),
  isHomePath: getIsHomePath(state),
  isHotelOnly: getIsHotelOnly(state),
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(Routes);
